var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteSectionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.8398 5.5L18.9537 20.121C18.8897 21.1766 18.0149 22 16.9573 22H7.7223C6.66472 22 5.78994 21.1766 5.72596 20.121L4.83984 5.5",
    stroke: "#1F2937",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.33984 5.5H8.33984M8.33984 5.5L9.58009 2.60608C9.73767 2.2384 10.0992 2 10.4992 2H14.1804C14.5804 2 14.942 2.2384 15.0995 2.60608L16.3398 5.5M8.33984 5.5H16.3398M21.3398 5.5H16.3398",
    stroke: "#1F2937",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteSectionIcon);
export default __webpack_public_path__ + "static/media/delete-section-icon.af7fb4654415542ad25f22dd6ce56622.svg";
export { ForwardRef as ReactComponent };